<template>
  <div class="z-main">
    <header class="z-header">
      <div @click="onBack">
       <img src="../../assets/sysbars/left.png" />
      </div>
      <div v-text="title"></div>
      <div>&nbsp;</div>
    </header>
    <div class="z-body z-padding10 z-body-bottom0 z-noticeDetail-content" style="width: 100%;flex:1;">
      <div v-html="content"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'noticeDetail',
    data() {
      return {
        title: '',
        content: '',
      }
    },
    mounted() {
      let _this = this
      _this.get('api/Futures/readNews', {
        id: _this.$route.query.id
      }).then((res) => {
        if (res.code == 0) {
          _this.title = res.data.title
          _this.content = res.data.content
        }
      })
    },
    methods: {
      onBack(){
        this.$router.go(-1);
      }
    },
    destroyed: function() {},
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .z-noticeDetail-content {
    color: #fff;
  }
  .z-noticeDetail-content img {
    max-width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/noticeDetail.vue